function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4E9CD3",
  fillOpacity: 0.65,
  fillRule: "nonzero",
  d: "M17.5 8.034a.649.649 0 0 0-.652-.646h-3.742a.163.163 0 0 1-.14-.08.16.16 0 0 1 0-.162l1.87-3.207a.642.642 0 0 0-.239-.882l-1.695-.968a.656.656 0 0 0-.891.236L10.14 5.53a.164.164 0 0 1-.283 0l-1.87-3.207a.656.656 0 0 0-.89-.236l-1.696.968a.642.642 0 0 0-.24.882l1.873 3.207a.16.16 0 0 1 0 .161.163.163 0 0 1-.141.081H3.152a.649.649 0 0 0-.652.646v1.936c0 .357.292.646.652.646h3.742a.16.16 0 1 1 .14.242l-1.87 3.207a.642.642 0 0 0 .239.882l1.695.968c.312.179.711.073.891-.236l1.87-3.207a.164.164 0 0 1 .284 0l1.87 3.207c.18.309.58.415.891.236l1.696-.968a.642.642 0 0 0 .238-.882l-1.87-3.207a.16.16 0 0 1 0-.161.163.163 0 0 1 .14-.081h3.74c.36 0 .652-.29.652-.646V8.034z"
});

var SvgRequired = function SvgRequired(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/required.b418be60.svg";
export { ForwardRef as ReactComponent };